import { ErrorModal } from "@dexteel/mesf-core";
import { Grid2, Paper } from "@mui/material";
import { GridApi } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";

import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { useTableData } from "../hooks/hooks";
import { DelayByShift } from "../models/DelayByShift";

type Props = {
	isLoading: boolean;
	rows: DelayByShift[];
	setGridApi: (params: GridApi) => void;
};

export const DelaysReportTable = ({ isLoading, rows, setGridApi }: Props) => {
	const [error, setError] = useState("");

	const { columns } = useTableData();
	const { defaultColDef } = useGridDefinitions({});

	return (
		<div onContextMenu={(e) => e.preventDefault()}>
			<Grid2 container>
				<Grid2
					size={{ xs: 12, md: 12 }}
					style={{
						padding: 10,
						height: "calc(100vh - 300px)",
						minHeight: "calc(100vh - 300px)",
						margin: "10px 0",
					}}
					component={Paper}
					elevation={2}
				>
					<AgGridReact
						loading={isLoading}
						rowData={rows}
						columnDefs={columns}
						defaultColDef={defaultColDef}
						animateRows
						rowHeight={38}
						headerHeight={35}
						tooltipShowDelay={0}
						tooltipHideDelay={2000}
						suppressContextMenu
						onGridReady={(params) => setGridApi(params.api)}
						loadingOverlayComponent={CenteredLazyLoading}
						gridOptions={{
							rowSelection: {
								mode: "singleRow",
								checkboxes: false,
								enableClickSelection: true,
							},
						}}
					/>
				</Grid2>
			</Grid2>
			<ErrorModal error={error} onHide={() => setError("")} />
		</div>
	);
};
